import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import iconsList from "@sunwing/icons/dist/vacances-westjet-quebec/icons.json";
import * as styles from "./Icons.module.scss";

const Icon = ({ name, className, title, hidden }) => (
	<span
		className={cx(`vwq-icon vwq-icon-${name}`, styles.icon, className)}
		aria-label={title}
		aria-hidden={hidden}
	/>
);
Icon.displayName = "Icon";

Icon.propTypes = {
	name: PropTypes.oneOf(iconsList).isRequired,
	className: PropTypes.string,
	title: PropTypes.string,
	hidden: PropTypes.bool,
};
Icon.defaultProps = {
	className: undefined,
	title: undefined,
	hidden: true,
};

export { Icon, iconsList };
